import React from "react";
import MediaPopover from "./MediaPopover";
import { useDispatch } from "react-redux";
import { closePopover } from "../../../store/common/uiSlice";
import AvatarPopover from "./avatar/AvatarPopover";
import ScriptPopover from "./ScriptPopover";
import AssetsPopover from "./AssetsPopover";
import VideoPopup from "./VideoPopover";
import TextPopover from "./TextPopover";
import MusicPopover from "./MusicPopover";
import { TemplatePopover } from "./templates";
import UseaiPopover from "./UseaiPopover";
const popoverComponents = {
  Avatars: AvatarPopover,
  Media: MediaPopover,
  Background: MediaPopover,
  Script: ScriptPopover,
  Assets: AssetsPopover,
  UseAI: UseaiPopover,
  Video: VideoPopup,
  Text: TextPopover,
  Music: MusicPopover,
  Themes: TemplatePopover,

  // Add more mappings as needed
};

const Popover = ({ type, bottom, ...props }) => {
  const dispatch = useDispatch();
  // Determine which component to render based on the provided type
  const SpecificPopoverComponent = popoverComponents[type] || null;

  if (!SpecificPopoverComponent) {
    // You can render a default fallback or return null if the type is not found
    console.log("No popover", SpecificPopoverComponent);
    return <div>Unsupported popover type</div>;
  }

  return (
    <div
      className="fixed inset-0 flex justify-center items-center z-10"
      onClick={() => dispatch(closePopover())}
    >
      <div
        className="border border-gray-300 shadow-md bg-white rounded-lg shadow-lg overflow-hidden w-2/3 h-2/3"
        style={{ position: "absolute", bottom: bottom }}
        onClick={(e) => e.stopPropagation()}
      >
        <SpecificPopoverComponent type={type} {...props} />
      </div>
    </div>
  );
};

export default Popover;
